import React, { useRef, useState } from "react";
import classes from "./styles.module.scss";
import TrendingCard from "../../components/Cards/TrendingCard";
import CardBig from "../../components/Cards/CardBig";
import CardSmall from "../../components/Cards/CardSmall";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { useArticle } from "../../context/ArticleContext";
import BlogLoading from "../../components/Loader/BlogLoading";
import NoDataFound from "../../components/helpers/NoDataFound/NoDataFound";
import Pagination from "../../components/Pagination/Pagination";
import { PAGE_LIMIT } from "../../utils/constants";

export default function Home() {
  const [searchByKeywordText, setSearchByKeywordText] = useState("");
  const trendingScrollRef1 = useRef();
  const trendingScrollRef2 = useRef();
  const trendingScrollRef3 = useRef();
  const articlesContext = useArticle();

  const handleScroll = (ref, direction) => {
    const newScrollLeft =
      ref.current.scrollLeft + (direction === "left" ? -100 : 100);
    ref.current.scrollLeft = newScrollLeft;
  };

  const handleNextPage = (currentPage, totalPages) => {
    if (currentPage < totalPages) {
      articlesContext.fetchAllArticles({
        page: currentPage + 1,
        limit: PAGE_LIMIT,
      });
    }
  };

  const handlePrevPage = (currentPage) => {
    if (currentPage > 1) {
      articlesContext.fetchAllArticles({
        page: currentPage - 1,
        limit: PAGE_LIMIT,
      });
    }
  };

  return (
    <div className={classes.Home}>
      <section className={classes.Home__search}>
        <div className={classes.Home__search__content}>
          <h1>Explore Heartwarming Pet Content Here!</h1>
          <div className={classes.Home__search__content__inputContainer}>
            <input
              type="text"
              name="searchByKeywordText"
              id="searchByKeywordText"
              value={searchByKeywordText}
              onChange={(e) => setSearchByKeywordText(e.target.value)}
              placeholder="Search Here"
            />
            <button>Search</button>
          </div>
        </div>
        <img
          src={"https://illustrations.popsy.co/orange/cute-bird.svg"}
          alt="bird"
        />
      </section>
      <section className={classes.Home__trending}>
        <div className={classes.Home__main}>
          <div className={classes.Home__main__todays}>
            <h2>Latest Articles</h2>
            <div className={classes.Home__main__todays__cards}>
              {articlesContext.state.loading ? (
                <BlogLoading length={3} />
              ) : articlesContext?.state?.data?.length ? (
                articlesContext?.state?.data?.map((d, idx) => (
                  <CardBig key={"CardBig" + d?.title + idx} data={d} />
                ))
              ) : (
                <NoDataFound
                  message={"No Articles Found"}
                  height={"50vh"}
                  width={"70%"}
                />
              )}
            </div>
            {!articlesContext.state.loading &&
            articlesContext?.state?.pagination ? (
              <Pagination
                currentPage={
                  articlesContext?.state?.pagination?.currentPage || 1
                }
                totalPages={articlesContext?.state?.pagination?.totalPages || 1}
                handlePrevPage={handlePrevPage}
                handleNextPage={handleNextPage}
              />
            ) : null}
          </div>
          <div className={classes.Home__main__popular}>
            <h2>Most Popular</h2>
            <div className={classes.Home__main__popular__cards}>
              {articlesContext.state.mostViewedAll.loading ? (
                <BlogLoading />
              ) : articlesContext?.state?.mostViewedAll?.data?.length ? (
                articlesContext?.state?.mostViewedAll?.data?.map((d, idx) => (
                  <CardSmall key={"CardSmall" + d?.title + idx} data={d} />
                ))
              ) : (
                <NoDataFound
                  message={"No Articles Found"}
                  height={"50vh"}
                  width={"100%"}
                />
              )}
            </div>
          </div>
        </div>
        {/* Trending Today */}
        <section className={classes.trendingSection}>
          <div className={classes.Home__main__trending}>
            <h2>Trending Today</h2>
            <div className={classes.Home__main__trending__controls}>
              <FontAwesomeIcon
                onClick={() => handleScroll(trendingScrollRef1, "left")}
                className={classes.Home__main__trending__controls__item}
                icon={faChevronLeft}
              />
              <FontAwesomeIcon
                onClick={() => handleScroll(trendingScrollRef1, "right")}
                className={classes.Home__main__trending__controls__item}
                icon={faChevronRight}
              />
            </div>
          </div>

          <div
            ref={trendingScrollRef1}
            className={classes.Home__trending__cards}
          >
            {articlesContext.state.mostViewedToday.loading ? (
              <BlogLoading />
            ) : articlesContext?.state?.mostViewedToday?.data?.length ? (
              articlesContext?.state?.mostViewedToday?.data?.map((d, idx) => (
                <TrendingCard key={"TrendingCard1" + d?.title + idx} data={d} />
              ))
            ) : (
              <NoDataFound
                message={"No Articles Found"}
                height={"50vh"}
                width={"70%"}
              />
            )}
          </div>
        </section>
        {/* Trending This Week */}
        <section className={classes.trendingSection}>
          <div className={classes.Home__main__trending}>
            <h2>Trending This Week</h2>
            <div className={classes.Home__main__trending__controls}>
              <FontAwesomeIcon
                onClick={() => handleScroll(trendingScrollRef2, "left")}
                className={classes.Home__main__trending__controls__item}
                icon={faChevronLeft}
              />
              <FontAwesomeIcon
                onClick={() => handleScroll(trendingScrollRef2, "right")}
                className={classes.Home__main__trending__controls__item}
                icon={faChevronRight}
              />
            </div>
          </div>

          <div
            ref={trendingScrollRef2}
            className={classes.Home__trending__cards}
          >
            {articlesContext.state.mostViewedWeek.loading ? (
              <BlogLoading />
            ) : articlesContext?.state?.mostViewedWeek?.data?.length ? (
              articlesContext?.state?.mostViewedWeek?.data?.map((d, idx) => (
                <TrendingCard key={"TrendingCard2" + d?.title + idx} data={d} />
              ))
            ) : (
              <NoDataFound
                message={"No Articles Found"}
                height={"50vh"}
                width={"70%"}
              />
            )}
          </div>
        </section>
        {/* Trending This Month */}
        <section className={classes.trendingSection}>
          <div className={classes.Home__main__trending}>
            <h2>Trending This Month</h2>
            <div className={classes.Home__main__trending__controls}>
              <FontAwesomeIcon
                onClick={() => handleScroll(trendingScrollRef3, "left")}
                className={classes.Home__main__trending__controls__item}
                icon={faChevronLeft}
              />
              <FontAwesomeIcon
                onClick={() => handleScroll(trendingScrollRef3, "right")}
                className={classes.Home__main__trending__controls__item}
                icon={faChevronRight}
              />
            </div>
          </div>

          <div
            ref={trendingScrollRef3}
            className={classes.Home__trending__cards}
          >
            {articlesContext.state.mostViewedMonth.loading ? (
              <BlogLoading />
            ) : articlesContext?.state?.mostViewedMonth?.data?.length ? (
              articlesContext?.state?.mostViewedMonth?.data?.map((d, idx) => (
                <TrendingCard key={"TrendingCard3" + d?.title + idx} data={d} />
              ))
            ) : (
              <NoDataFound
                message={"No Articles Found"}
                height={"50vh"}
                width={"70%"}
              />
            )}
          </div>
        </section>
      </section>
    </div>
  );
}
